import React from 'react';
import { differenceInCalendarDays } from 'date-fns';
import icons from '../../assets/icons';

const columns = [
  {
    id: 'imported',
    type: 'boolean',
    accessor: campaign => renderImportedIcon(campaign.imported),
    disableSortBy: true
  },
  {
    Header: 'Campaign',
    id: 'campaign',
    type: 'string',
    accessor: campaign => campaign.displayName || '--',
    disableSortBy: true
  },
  {
    Header: 'Start Date',
    id: 'startDate',
    type: 'string',
    accessor: campaign => {
      const date = new Date(campaign.startTime);
      return date.toLocaleDateString() || '--';
    },
    disableSortBy: true
  },
  {
    Header: 'End Date',
    id: 'endDate',
    type: 'string',
    accessor: campaign => renderEndDate(campaign.endTime),
    disableSortBy: true
  },
  {
    Header: () => (
      <span title="Days from campaign start to end, or today if ongoing, including both dates.">
        Duration (days)
      </span>
    ),
    id: 'duration',
    type: 'number',
    accessor: campaign => renderDuration(campaign),
    disableSortBy: true
  },
  {
    Header: 'Sites Count',
    id: 'sitesCount',
    type: 'number',
    accessor: campaign => campaign.sitesCount || 0,
    disableSortBy: true
  }
];

const renderImportedIcon = imported => {
  if (imported) {
    return <img src={icons.imported} alt="Imported Campaign" title="Imported Campaign" />;
  }
};

const renderEndDate = endDate => {
  const date = new Date(endDate);
  const year = date.getFullYear();
  if (year === 9999) {
    return 'Ongoing';
  }
  return date.toLocaleDateString() || '--';
};

const renderDuration = campaign => {
  const start = new Date(campaign.startTime);
  const end = campaign.endTime ? new Date(campaign.endTime) : new Date();
  if (
    !campaign.startTime ||
    !Number.isFinite(start.getTime()) ||
    !Number.isFinite(end.getTime()) ||
    (campaign.endTime && end < start)
  ) {
    return '--';
  }
  return Math.max(0, differenceInCalendarDays(new Date(Math.min(end.getTime(), Date.now())), start) + 1);
};

export default columns;
